import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Upload, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import i18n from '../../../Shared/Translation/i18n';
import { ApiUrl } from '../../../project/Defines.js';
import { dispatchCustomEvent, EVENT_NAME } from '../../../project/utilities';
import DetailView from '../../../Shared/DetailView';
import useDetail from '../../../Shared/useDetail';
import InputCont from '../../../Shared/Form/InputCont';
import { InputValidationIcon } from '../../../Shared/Form/validation';

const listUpdateEvent = EVENT_NAME.THERCODIM_LINKS_LIST_UPDATE;

export default function ThercodimLinksDetails(props) {
    const { windowKey, data } = props;
    const { id } = useParams();

    const { dataItem, setDataItem, updateData, hasChanges, closePopup, detailRef, onChangeData, validation } = useDetail({
        data: data || { ID: id !== 'create' ? id : 0 },
        windowKey,
        updateUrl: ApiUrl.ThercodimLinksUpdate,
        dataLoadUrl: ApiUrl.ThercodimLinksLoad,
        deleteUrl: ApiUrl.ThercodimLinksDelete,
        nameField: 'name',
        listUpdateEvent,
        validationFields: ['name', 'url', 'logoBase64'],
    });

    const updateSuccessCallback = useCallback((response) => {
        if (detailRef.current) {
            setDataItem(response);
            dispatchCustomEvent(listUpdateEvent, { action: 'update' });
            closePopup();
        }
    }, [setDataItem, detailRef, closePopup]);

    const handleLogoUpload = useCallback((file) => {
        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            message.error(i18n('text.upload_image_only') || 'You can only upload image files!');
            return false;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            setDataItem((prev) => ({ ...prev, logoBase64: e.target.result }));
        };
        reader.readAsDataURL(file);
        return false;
    }, [setDataItem]);

    return (<>
        {dataItem && <DetailView hasChanges={hasChanges}>
            <view>
                <div className="form_container">
                    <div className="section_group">
                        <div className="sections">
                            <InputCont
                                label='text.name'
                                inputProps={{ validation, name: 'name', maxLength: '255', value: dataItem.name || '', onChange: onChangeData }}
                            />
                            <InputCont
                                label='text.url'
                                inputProps={{ validation, name: 'url', maxLength: '2000', value: dataItem.url || '', onChange: onChangeData }}
                            />
                            <InputCont
                                label='text.description'
                                inputProps={{ name: 'description', type: 'textarea', maxLength: '500', value: dataItem.description || '', onChange: onChangeData }}
                            />
                            <div className="form_fields required">
                                <label style={!validation.isValid && validation['logoBase64'] ? { color: 'tomato' } : {}}>{i18n('text.logo')}</label>
                                <div className='input_cont'>
                                    <Upload
                                        listType="picture-card"
                                        showUploadList={false}
                                        beforeUpload={handleLogoUpload}
                                        accept="image/*"
                                    >
                                        {dataItem.logoBase64 ? (
                                            <img src={dataItem.logoBase64} alt="logo" style={{ width: '100%', maxHeight: 100, objectFit: 'contain' }} />
                                        ) : (
                                            <div>
                                                <PlusOutlined />
                                                <div style={{ marginTop: 8 }}>{i18n('text.upload') || 'Upload'}</div>
                                            </div>
                                        )}
                                    </Upload>
                                    <InputValidationIcon messages={validation['logoBase64']} validate={!validation.isValid} />
                                </div>
                                {dataItem.logoBase64 && (
                                    <div
                                        className="button"
                                        style={{ marginTop: 4, display: 'inline-block' }}
                                        onClick={() => setDataItem((prev) => ({ ...prev, logoBase64: '' }))}
                                    >
                                        <icon>delete</icon>{i18n('text.remove') || 'Remove'}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <toolbar>
                    <wrap>
                        <action right=''>
                            <div
                                onClick={() => updateData(updateSuccessCallback)}
                                className={hasChanges ? 'button primary' : 'button'}
                                disabled={validation?.isValid ? false : true}
                            >
                                <icon>save</icon>{i18n('text.save')}
                            </div>
                        </action>
                    </wrap>
                </toolbar>
            </view>
        </DetailView>}
    </>);
}
